import invariant from 'invariant';
import { isEmpty, isString } from 'lodash';

import checkStore from './checkStore';
import createReducer from '../../app/reducers';

export function injectReducerFactory(store, isValid) {
  return function injectReducer(key, reducer) {
    if (!isValid) checkStore(store);
    // console.log('reduceInjectors: ', store);
    // console.log('key: ', key);
    invariant(
      // isString(key) && !isEmpty(key) && isFunction(reducer),
      isString(key) && !isEmpty(key),
      '(app/utils...) injectReducer: Expected `reducer` to be a reducer function'
    );

    // Check `store.injectedReducers[key] === reducer` for hot reloading when a key is the same but a reducer is different
    if (Reflect.has(store.injectedReducers, key) && store.injectedReducers[key] === reducer) {
      return;
    }

    store.injectedReducers[key] = reducer;
    store.replaceReducer(createReducer(store.injectedReducers));
  };
}

export default function getInjectors(store) {
  checkStore(store);

  return {
    injectReducer: injectReducerFactory(store, true)
  };
}
